// Liens vers la page « Mentions légales et données » du club (D-103) : en pied de chaque page publique
// (page du club, page partenaires, connexion, invitations, saisie des stats) et près de chaque case de
// consentement. Sur le sous-domaine du club : /donnees ; sinon /c/<adresse>/donnees, ou <lien reçu>/donnees ;
// à défaut, la politique de confidentialité de l'app.
import { clubHostSlug } from '../domain/slug';
import { PRIVACY_URL } from '../domain/legal';
import { html, type Html } from './dom';
import './legal.css';

export const LEGAL_LABEL = 'Mentions légales et données';
const HOST_BASE = (import.meta.env.VITE_CLUB_HOST_BASE as string | undefined)?.trim();

/** Le sous-domaine du club affiché, s'il y en a un. */
export const hostClubSlug = (): string | null => clubHostSlug(location.hostname, HOST_BASE);

/** L'adresse de la page des données : celle du club (sous-domaine, adresse publique, lien reçu), sinon celle de l'app. */
export function dataHref(o: { slug?: string | null; via?: string | null } = {}): string {
  if (hostClubSlug()) return '/donnees';
  if (o.slug) return `/c/${o.slug}/donnees`;
  if (o.via) return `${o.via.replace(/\/$/, '')}/donnees`;
  return PRIVACY_URL;
}

/** Le lien du pied de page. */
export const legalFootLink = (href: string, cls = 'lg-foot-link'): Html =>
  html`<a class="${cls}" href="${href}" ${href.startsWith('http') ? html`target="_blank" rel="noopener"` : ''}>${LEGAL_LABEL}</a>`;

/** La ligne sous une case de consentement (vouvoiement : pages publiques). */
export const consentNote = (href: string, tu = false): Html =>
  html`<p class="lg-consent">${tu ? 'Tes' : 'Vos'} données et ${tu ? 'tes' : 'vos'} droits : <a href="${href}" target="_blank" rel="noopener">${LEGAL_LABEL}</a></p>`;
